import React, { useState } from 'react'
import './signUp.css'
import { Row } from 'antd';
import Footer from '../../component/footer/footer'
// import { SteponeLeft, SteponeRight } from '../../component/signup_wizard/stepone/StepOne'
import { SteptwoLeft, SteptwoRight } from '../../component/signup_wizard/steptwo/StepTwo'
import StepThree from '../../component/signup_wizard/stepthree/StepThree'
import Success from '../../component/signup_wizard/success/success'

const Register = () => {

    // const [stepOneDone, setStepOneDone] = useState(true)
    const [stepTwoDone, setStepTwoDone] = useState(true)
    const [stepThreeDone, setStepThreeDone] = useState(false)
    const [successful, setSuccessful] = useState(false)

    // const oneDone = () => {
    //     setStepOneDone(false)
    //     setStepTwoDone(true)
    // }

    const twoDone = () => {
        setStepTwoDone(false)
        setStepThreeDone(true)
    }

    const successDone = () => {
        setStepThreeDone(false)
        setSuccessful(true)
    }

    return(
        <div>
            <div className="signup_conatianer">
                <Row className="signup_holder">
                    {/* <SteponeLeft stepOneDone={stepOneDone}/> */}
                    <SteptwoLeft stepTwoDone={stepTwoDone}/>

                    <StepThree stepThreeDone={stepThreeDone} successDone={successDone}/>
                    <Success successful={successful}/>

                    <SteptwoRight twoDone={twoDone} stepTwoDone={stepTwoDone}/>
                    {/* <SteponeRight oneDone={oneDone} stepOneDone={stepOneDone}/> */}
                </Row>
            </div>
            <Footer />
        </div>
    );
}

export default Register;